/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * PwC Web App Accelerator API
 * OpenAPI spec version: 1.0
 */

export type OrderByRequest =
    (typeof OrderByRequest)[keyof typeof OrderByRequest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderByRequest = {
    DateAscending: 'DateAscending',
    DateDescending: 'DateDescending',
} as const;
